import React from "react";
import { Link } from "gatsby";
import marked from 'marked';

import CDNImage from '../../common/cdn-image';

import '../../../styles/shop/product-list.scss';

class ProductList extends React.Component {
  render() {
    let start, products;
    if  (this.props.perPage) {
      start = (this.props.page - 1) * this.props.perPage;
      products = this.props.products.slice(start, start + this.props.perPage);
    } else {
      products = this.props.products;
    }

    return (
      <ul className="product-list">
        {products.map(({ node }, idx) => {
          let productPath = '';
          
          if (node.data.Special_Product_Page) {
            productPath = `/shop/${node.data.Special_Page_Path}`;
          } else {
            productPath = `/product/${node.data.Reference}`;
          }
          
          return (
            <li key={`${node.data.Reference}-${idx}`}>
              <Link to={ productPath }>
                <div className="product-cell__image-frame-wrapper">
                  <div className="product-cell__image-frame">
                    {(node.data.Image_File_Path) ? (
                      <CDNImage
                        imagePath={node.data.Image_File_Path}
                        alt={node.data.Name}
                        height={792}
                        width={792}
                      />
                    ) : null}
                  </div>
                </div>
                <div className="product-cell__label">
                  <span
                    className="name"
                    dangerouslySetInnerHTML={{ __html: marked(node.data.Name).replace('<p>','').replace('</p>','') }}
                  />
                  {(node.data.Artist) ? (
                      <span className="artist">
                        {node.data.Artist}
                        {(node.data.Year) ? (
                          <>, {node.data.Year}</>
                        ) : null}
                      </span>
                  ) : null}
                  {node.data.Unavailable && (
                      <span className="unavailable-tag">Currently Unavailable</span>
                  )}
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    );
  }
}

export default ProductList;
